export class SentryPayloadParseError extends Error {
    constructor(options: ErrorOptions) {
        super('Error parsing payload for Sentry report.', options);
        this.name = 'SentryPayloadParseError';
    }
}
